import BrowserHistoryManager from "../utilities/dom/browserHistoryManager";
import CustomModalManager from "../utilities/customModalManager";

export default class ServicesController
{
    constructor() {
        this.services = {};
        this.initializeServices();
    }

    initializeServices()
    {
        this.services[BrowserHistoryManager.className] = new BrowserHistoryManager();
        this.services[CustomModalManager.className] = new CustomModalManager();
    }

    getService(key, params = {})
    {
        const service = this.services[key];
        for (const [key, param] of Object.entries(params)) {
            if (service.acceptedParams && service.acceptedParams.includes(key)) {
                service.setCustomParam(key, param);
            }
        }

        return service;
    }
}
